import { render, staticRenderFns } from "./RiskConferenceSafetyUpdate.vue?vue&type=template&id=36da6dd0&scoped=true"
import script from "./RiskConferenceSafetyUpdate.vue?vue&type=script&lang=js"
export * from "./RiskConferenceSafetyUpdate.vue?vue&type=script&lang=js"
import style1 from "./RiskConferenceSafetyUpdate.vue?vue&type=style&index=1&id=36da6dd0&prod&lang=scss&scoped=true"
import style2 from "./RiskConferenceSafetyUpdate.vue?vue&type=style&index=2&id=36da6dd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36da6dd0",
  null
  
)

export default component.exports